import { render, staticRenderFns } from "./THYNDCProvider.vue?vue&type=template&id=18cd1b96&scoped=true&"
import script from "./THYNDCProvider.vue?vue&type=script&lang=js&"
export * from "./THYNDCProvider.vue?vue&type=script&lang=js&"
import style0 from "./THYNDCProvider.vue?vue&type=style&index=0&id=18cd1b96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18cd1b96",
  null
  
)

export default component.exports